import React, { useEffect, useState } from 'react';
import { get } from '../../ApiServices/ApiServices';
import { useNavigate } from 'react-router-dom';;

function TopMetrics({ ActiveOrder }) {

    return (
        <>
            <h5 className="mb-3">Top Metrics for Active Orders</h5>
            <div className="row g-gs">
                {/* Your metric cards remain the same */}
                <div className="col-xxl-3 col-sm-3">
                    <div className="cardBoxOrder">
                        <div className="cardBoxOrdersInner">
                            <div className="leftCOrder">
                                <h6>{ActiveOrder?.total_count ?? "N/A"}</h6>
                                <p>Total Active Orders</p>
                            </div>
                            <span><img src="assets/images/d1.svg" alt="" /></span>
                        </div>
                        <div className="infUpDown">
                            <span className={ActiveOrder?.total_count_change?.direction === 'increase' ? '' : 'redDown'}>
                                <em className={`icon ni ni-arrow-long-${ActiveOrder?.total_count_change?.direction === 'increase' ? 'up' : 'down'} `}></em>
                                {ActiveOrder?.total_count_change?.value ?? 0}%
                            </span>
                            <small>Since last month</small>
                        </div>
                    </div>
                </div>

                {/* Add other metric cards here */}


                <div className="col-xxl-3 col-sm-3">
                    <div className="cardBoxOrder">
                        <div className="cardBoxOrdersInner">
                            <div className="leftCOrder">
                                <h6>{ActiveOrder?.total_wedding_order_count ?? "N/A"}</h6>
                                <p>Wedding Orders</p>
                            </div>
                            <span><img src="assets/images/d5.svg" alt="" /></span>
                        </div>
                        <div className="infUpDown">
                            <span className={ActiveOrder?.wedding_order_change?.direction === 'increase' ? '' : 'redDown'}>
                                <em className={`icon ni ni-arrow-long-${ActiveOrder?.wedding_order_change?.direction === 'increase' ? 'up' : 'down'} `}></em>
                                {ActiveOrder?.wedding_order_change?.value ?? 0}%
                            </span>
                            <small>Since last month</small>
                        </div>
                    </div>
                </div>

                <div className="col-xxl-3 col-sm-3">
                    <div className="cardBoxOrder">
                        <div className="cardBoxOrdersInner">
                            <div className="leftCOrder">
                                <h6>{ActiveOrder?.total_single_order_count ?? "N/A"}</h6>
                                <p>Single Orders</p>
                            </div>
                            <span><img src="assets/images/d4.svg" alt="" /></span>
                        </div>
                        <div className="infUpDown">
                            <span className={ActiveOrder?.single_order_change?.direction === 'increase' ? '' : 'redDown'}>
                                <em className={`icon ni ni-arrow-long-${ActiveOrder?.single_order_change?.direction === 'increase' ? 'up' : 'down'} `}></em>
                                {ActiveOrder?.single_order_change?.value ?? 0}%
                            </span>
                            <small>Since last month</small>
                        </div>
                    </div>
                </div>
                <div className="col-xxl-3 col-sm-3">
                    <div className="cardBoxOrder">
                        <div className="cardBoxOrdersInner">
                            <div className="leftCOrder">
                                <h6>{ActiveOrder?.total_prom_order_count ?? "N/A"}</h6>
                                <p>Prom Orders</p>
                            </div>
                            <span><img src="assets/images/d6.svg" alt="" /></span>
                        </div>
                        <div className="infUpDown">
                            <span className={ActiveOrder?.prom_order_change?.direction === 'increase' ? '' : 'redDown'}>
                                <em className={`icon ni ni-arrow-long-${ActiveOrder?.prom_order_change?.direction === 'increase' ? 'up' : 'down'} `}></em>
                                {ActiveOrder?.prom_order_change?.value ?? 0}%
                            </span>
                            <small>Since last month</small>
                        </div>
                    </div>
                </div>

                <div className="col-xxl-3 col-sm-3">
                    <div className="cardBoxOrder">
                        <div className="cardBoxOrdersInner">
                            <div className="leftCOrder">
                                <h6>{ActiveOrder?.total_count_for_ship_prep ?? "N/A"}</h6>
                                <p>Orders Prepared To Ship</p>
                            </div>
                            <span><img src="assets/images/d3.svg" alt="" /></span>
                        </div>
                        <div className="infUpDown">
                            <span className={ActiveOrder?.ship_prep_change?.direction === 'increase' ? '' : 'redDown'}>
                                <em className={`icon ni ni-arrow-long-${ActiveOrder?.ship_prep_change?.direction === 'increase' ? 'up' : 'down'} `}></em>
                                {ActiveOrder?.ship_prep_change?.value ?? 0}%
                            </span>
                            <small>Since last month</small>
                        </div>
                    </div>
                </div>

                <div className="col-xxl-3 col-sm-3">
                    <div className="cardBoxOrder">
                        <div className="cardBoxOrdersInner">
                            <div className="leftCOrder">
                                <h6>{ActiveOrder?.total_shipped_this_week_count ?? "N/A"}</h6>
                                <p>Orders Shipped This Week</p>
                            </div>
                            <span><img src="assets/images/d2.svg" alt="" /></span>
                        </div>
                        <div className="infUpDown">
                            <span className={ActiveOrder?.shipped_this_week_change?.direction === 'increase' ? '' : 'redDown'}>
                                <em className={`icon ni ni-arrow-long-${ActiveOrder?.shipped_this_week_change?.direction === 'increase' ? 'up' : 'down'} `}></em>
                                {ActiveOrder?.shipped_this_week_change?.value ?? 0}%
                            </span>
                            <small>Since last month</small>
                        </div>
                    </div>
                </div>

                <div className="col-xxl-3 col-sm-3">
                    <div className="cardBoxOrder">
                        <div className="cardBoxOrdersInner">
                            <div className="leftCOrder">
                                <h6>{ActiveOrder?.total_return_due_count ?? "N/A"}</h6>
                                <p>Orders Due For Return This Week</p>
                            </div>
                            <span><img src="assets/images/d8.svg" alt="" /></span>
                        </div>
                        <div className="infUpDown">
                            <span className={ActiveOrder?.return_due_change?.direction === 'increase' ? '' : 'redDown'}>
                                <em className={`icon ni ni-arrow-long-${ActiveOrder?.return_due_change?.direction === 'increase' ? 'up' : 'down'} `}></em>
                                {ActiveOrder?.return_due_change?.value ?? 0}%
                            </span>
                        </div>
                    </div>
                </div>

                <div className="col-xxl-3 col-sm-3">
                    <div className="cardBoxOrder">
                        <div className="cardBoxOrdersInner">
                            <div className="leftCOrder">
                                <h6>{ActiveOrder?.total_delinquent_count ?? "N/A"}</h6>
                                <p>Delinquent Orders </p>
                            </div>
                            <span><img src="assets/images/d7.svg" alt="" /></span>
                        </div>
                        <div className="infUpDown">
                            <span className={ActiveOrder?.delinquent_change?.direction === 'increase' ? '' : 'redDown'}>
                                <em className={`icon ni ni-arrow-long-${ActiveOrder?.delinquent_change?.direction === 'increase' ? 'up' : 'down'} `}></em>
                                {ActiveOrder?.delinquent_change?.value ?? 0}%
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TopMetrics
